export function stripAuth0PasswordResetParams(
  locationRef: Pick<Location, 'href'> = window.location,
  historyRef: Pick<History, 'replaceState'> = window.history
): void {
  const url = new URL(locationRef.href);
  if (url.searchParams.has('success') || url.searchParams.has('message')) {
    url.searchParams.delete('success');
    url.searchParams.delete('message');
    historyRef.replaceState(null, '', url.pathname + url.search);
  }
}
